import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

const gsapInstance = gsap;
gsapInstance.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default gsapInstance;
